/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QuestionsCopyStats,
    QuestionsCopyStatsFromJSON,
    QuestionsCopyStatsFromJSONTyped,
    QuestionsCopyStatsToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestionsCopyStatsResponse
 */
export interface QuestionsCopyStatsResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof QuestionsCopyStatsResponse
     */
    msg: string;
    /**
     * 
     * @type {QuestionsCopyStats}
     * @memberof QuestionsCopyStatsResponse
     */
    entry: QuestionsCopyStats;
}

export function QuestionsCopyStatsResponseFromJSON(json: any): QuestionsCopyStatsResponse {
    return QuestionsCopyStatsResponseFromJSONTyped(json, false);
}

export function QuestionsCopyStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionsCopyStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': QuestionsCopyStatsFromJSON(json['entry']),
    };
}

export function QuestionsCopyStatsResponseToJSON(value?: QuestionsCopyStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': QuestionsCopyStatsToJSON(value.entry),
    };
}


